export default {"src":"/_next/static/media/input-search.64824e03.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};